export default __webpack_public_path__ + "static/media/GretchenLovelace.13103de4.png";